import { useAuthStore, type LanguageMode } from '../../lib/auth-store'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card'
import { SegmentedTabs } from '../ui/segmented-tabs'

export function InterfacePreferencesSection() {
  const languageMode = useAuthStore((s) => s.languageMode)
  const setLanguageMode = useAuthStore((s) => s.setLanguageMode)
  return (
    <Card>
      <CardHeader>
        <CardTitle>Interface language</CardTitle>
        <CardDescription>
          Controls how much technical detail appears in the chat while Claude is
          building. <strong className="text-foreground">Simple</strong> hides tool output and file paths from
          the live status line; <strong className="text-foreground">Technical</strong> shows everything raw.
          Either way, the full log is available behind <em>Show details</em>.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <SegmentedTabs<LanguageMode>
          size="sm"
          value={languageMode}
          onChange={(m) => setLanguageMode(m)}
          items={[
            { value: 'moderate', label: 'Simple' },
            { value: 'technical', label: 'Technical' },
          ]}
        />
        <p className="text-xs text-muted-foreground">
          This setting is stored in your browser only. Switch devices and you'll
          be back to Simple.
        </p>
      </CardContent>
    </Card>
  )
}
